const axios = require("axios");
import { appInDevMode } from "./helpers";
import { useNotifications } from "../store/notifications.store";

const transport = axios.create({
    withCredentials: true,
});

transport.interceptors.response.use(
    (response) => response,
    (error) => {
        if(appInDevMode()){
            const notificationsStore = useNotifications();
            notificationsStore.notify(error.message, 'error')
        }
        
        if(error?.response != null && error?.response?.status === 401) {
            localStorage.removeItem('user')
            window.location.href = "/login"
        }

        return Promise.reject(error)
  });

export default transport;
